import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationFeature, UserRole } from "@green0meter/api-client";
import { Collapse } from "@mui/material";

import { Alert, Button } from "@components/base";
import { useUserStore } from "@store/user";
import { useGetCurrentCompanyInfo, useUpdateCompanyDemoData } from "@api";

const DemoDataAlert: FC = (): JSX.Element => {
  const { user } = useUserStore();
  const { currentCompanyInfo } = useGetCurrentCompanyInfo(user);
  const { updateCompanyDemoData } = useUpdateCompanyDemoData(user);
  const { t } = useTranslation();

  const hasOverviews =
    currentCompanyInfo?.companyFeatureFunctionalities?.some(
      (feature) =>
        feature.applicationFeature === ApplicationFeature.CSRD ||
        feature.applicationFeature === ApplicationFeature.CO2,
    ) ?? false;

  return (
    <>
      {hasOverviews && currentCompanyInfo?.isDemoDataEnabled && user?.role !== UserRole.Respondent && (
        <Collapse
          in={currentCompanyInfo.isDemoDataEnabled}
          sx={{ width: "100%" }}
          unmountOnExit
        >
          <Alert
            severity="warning"
            variant="outlined"
            action={
              <Button
                color="warning"
                size="small"
                onClick={() => {
                  updateCompanyDemoData({
                    companyId: currentCompanyInfo.id,
                    status: false,
                  });
                }}
              >
                {t("common.clear")}
              </Button>
            }
          >
            {t("alert.message.demo_data")}
          </Alert>
        </Collapse>
      )}
    </>
  );
};

export default DemoDataAlert;
